import '~/assets/dev/styles.scss';

jQuery(document).ready(function($) {

	// Focus styles for menus when using keyboard navigation
	// Properly update the ARIA states on focus (keyboard) and mouse over events
	$( '[role="menubar"]' ).on( 'focus.aria mouseenter.aria', '[aria-haspopup="true"]', function ( ev ) {
		$( ev.currentTarget ).attr( 'aria-expanded', true );
	});
	// Properly update the ARIA states on blur (keyboard) and mouse out events
	$( '[role="menubar"]' ).on( 'blur.aria mouseleave.aria', '[aria-haspopup="true"]', function ( ev ) {
		$( ev.currentTarget ).attr( 'aria-expanded', false );
	});

	let initReadOnly = function() {
		$('.read-only input').each(function () {
            console.log('Setting readonly for:', this);
            $(this).prop('readonly', true); // Prefer .prop for boolean attributes
        });
	}
	initReadOnly();

	$(window).on('load', function() {
	
	});

	var resizeTimer;

	$(window).on('resize', function(e) {

	  clearTimeout(resizeTimer);
	  resizeTimer = setTimeout(function() {
	            
	  }, 50);

	});

});

document.addEventListener("DOMContentLoaded", () => {
	
	/////////////////////////////////////////////////
	// Start: Toggle Dashboard Latest Tabs (Simplified)
	////////////////////////////////////////////////

	let ViewTabFilter = document.getElementById("ViewTabFilter");
	let ViewTab_1 = document.getElementById("ViewTab_1");
	let ViewTab_2 = document.getElementById("ViewTab_2");

	// Check to see if dashboard filter exists on page
	if(ViewTabFilter) {
		ViewTabFilter.addEventListener('change', function() {
			const selectedValue = ViewTabFilter.value;

			if (selectedValue === "tab_1") {
				ViewTab_1.classList.add("active");
				ViewTab_2.classList.remove("active");
			} else {
				ViewTab_2.classList.add("active");
				ViewTab_1.classList.remove("active");
			}
		});
	}

	/////////////////////////////////////////////////
	// End: Toggle Dashboard Latest Tabs
	////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Start: Toggle Resource Latest Tabs
	////////////////////////////////////////////////
	/*
	let resourceTabs = document.querySelector(".resource-tab-item");
	let resourceAllTab = document.getElementById("resourceAllTab");
	let resourceDocsTab = document.getElementById("resourceDocsTab");
	let resourceTemplatesTab = document.getElementById("resourceTemplatesTab");
	let resourceRecordingsTab = document.getElementById("resourceRecordingsTab");
	let resourceToolkitsTab = document.getElementById("resourceToolkitsTab");


	let dashboardNewsPosts = document.getElementById("dashboardPostsNews");
	let dashboardEventsPosts = document.getElementById("dashboardPostsEvents");

	// Check to see if dashboard tabs exist on page
	if(dashboardTab) {

		// Once News Tab title is clicked, remove active class from Events and add to News
		//Also activate corresponding News post section
		dashboardNewsTab.addEventListener('click', (e) => {
			if (!dashboardNewsTab.classList.contains('active')){
				
				dashboardNewsTab.classList.add("active");
				dashboardEventsTab.classList.remove("active");

				dashboardNewsPosts.classList.add("active");
				dashboardEventsPosts.classList.remove("active");
				
			}
			
		});

		// Once Events Tab title is clicked, remove active class from News  and add to News
		//Also activate corresponding Events post section
		dashboardEventsTab.addEventListener('click', (e) => {
			if (!dashboardEventsTab.classList.contains('active')){
				
				dashboardEventsTab.classList.add("active");
				dashboardNewsTab.classList.remove("active");

				dashboardEventsPosts.classList.add("active");
				dashboardNewsPosts.classList.remove("active");

			}
			
		});
	}
	*/
	
	/////////////////////////////////////////////////
	// End: Toggle Dashboard Latest Tabs
	////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Start: Add Line to Nav Menu
	////////////////////////////////////////////////

	let demarcation = document.querySelectorAll(".demarcation");
	let hr_ = document.createElement("hr");
	hr_.classList.add('nav-divider');

	if(demarcation) {
		//console.log('it does exist so the line of demarcation will be added');
		// Loop through all nav menu links with sub-menu items
		

		demarcation.forEach(demarcation => {
			demarcation.parentNode.insertBefore(hr_.cloneNode(true), demarcation.nextSibling); // Use cloneNode to avoid moving the same element
		});
	}

	/////////////////////////////////////////////////
	// End: Add Line to Nav Menu
	////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Start: Accordion
	////////////////////////////////////////////////


	let acc = document.getElementsByClassName("quick-link-title");

	if (acc){
		for (let i = 0; i < acc.length; i++) {
			acc[i].addEventListener("click", function() {
				this.classList.toggle("active");
				let panel = this.nextElementSibling;
				if (panel.style.display === "block") {
				panel.style.display = "none";
				} else {
				panel.style.display = "block";
				}
			});
		}
	}

	/////////////////////////////////////////////////
	// End: Accordion
	////////////////////////////////////////////////


	/////////////////////////////////////////////////
	// Start: Main Nav Sub Menu Toggle
	////////////////////////////////////////////////
	// Parent links are now navigable; the .submenu-toggle button emitted by
	// Aria_Walker_Nav_Menu owns opening the sub-menu.
	//
	// Desktop (.dashboard-left) shows the sub-menu as a flyout panel to the right of the
	// sidebar, so a tall menu no longer grows the sidebar past the viewport. Mobile
	// (.mobile-nav) keeps the original accordion.
	//
	// The flyout is position:fixed — the sidebar has overflow:scroll, which would clip an
	// absolutely positioned panel — so its coordinates are set here.
	(function mainNavSubMenus() {
		const FLYOUT_GAP = 8;    // space between sidebar edge and panel
		const VIEWPORT_MARGIN = 8; // keep the panel this far from the viewport edges

		const toggles = document.querySelectorAll('.submenu-toggle');
		if (!toggles.length) return;

		let openFlyout = null; // the currently open desktop <li>, if any

		function isDesktopFlyout(li) {
			return !!li.closest('.dashboard-left');
		}

		function setExpanded(li, expanded) {
			li.classList.toggle('open', expanded);
			const btn = li.querySelector(':scope > .submenu-toggle');
			if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		}

		function positionFlyout(li) {
			const panel = li.querySelector(':scope > .sub-menu');
			if (!panel) return;

			const anchor = li.getBoundingClientRect();

			// Measure after the panel is displayed so height is real.
			const panelHeight = panel.offsetHeight;

			let top = anchor.top;
			const maxTop = window.innerHeight - panelHeight - VIEWPORT_MARGIN;
			if (top > maxTop) top = maxTop;
			if (top < VIEWPORT_MARGIN) top = VIEWPORT_MARGIN;

			panel.style.left = (anchor.right + FLYOUT_GAP) + 'px';
			panel.style.top = top + 'px';
		}

		function closeFlyout(returnFocus) {
			if (!openFlyout) return;
			const li = openFlyout;
			openFlyout = null;
			setExpanded(li, false);
			if (returnFocus) {
				const btn = li.querySelector(':scope > .submenu-toggle');
				if (btn) btn.focus();
			}
		}

		toggles.forEach(btn => {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				const li = this.closest('.menu-item-has-children');
				if (!li) return;

				const wasOpen = li.classList.contains('open');

				if (!isDesktopFlyout(li)) {
					// Mobile accordion: independent toggles, nothing to position.
					setExpanded(li, !wasOpen);
					return;
				}

				// Desktop: only one flyout open at a time.
				closeFlyout(false);

				if (!wasOpen) {
					setExpanded(li, true);
					openFlyout = li;
					positionFlyout(li);
				}
			});
		});

		// Close on outside click, but not when clicking inside the panel itself.
		document.addEventListener('click', function (e) {
			if (!openFlyout) return;
			if (openFlyout.contains(e.target)) return;
			closeFlyout(false);
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && openFlyout) closeFlyout(true);
		});

		// Anything that moves the anchor invalidates the panel's position.
		window.addEventListener('resize', () => closeFlyout(false));

		const navInner = document.querySelector('.dashboard-left .dashboard-nav-inner');
		if (navInner) {
			navInner.addEventListener('scroll', () => closeFlyout(false));
		}
	})();



	/////////////////////////////////////////////////
	// Start: Add Author Path to Profile URL link
	////////////////////////////////////////////////

	let currentUSerNiceNameId = document.getElementById("authorName1");
	let authorProfileLink = document.getElementsByClassName("profile-link");

	if(currentUSerNiceNameId){
		let currentUSerNiceNameValue = currentUSerNiceNameId.getAttribute("data-nice-name");

		//console.log("the user's nicename is " + currentUSerNiceNameValue);

		if(authorProfileLink){
			for (let i = 0; i < authorProfileLink.length; i++) {
				let authorProfileLinkAnchor =  authorProfileLink[i].getElementsByTagName('a');
				authorProfileLinkAnchor[0].href = authorProfileLinkAnchor[0].href + currentUSerNiceNameValue;

				//authorProfileLink[i].href = authorProfileLink[i].href + currentUSerNiceNameValue;
			}
		}
	}

	/////////////////////////////////////////////////
	// End: Accordion
	////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Start: Toggle Mobile Nav
	////////////////////////////////////////////////

	let mobileNavToggler = document.querySelector("#mobileNavToggler");
	let mobileNavbarSupportedContent = document.querySelector("#mobileNavbarSupportedContent");

	if (mobileNavToggler) {
		mobileNavToggler.addEventListener('click', function() {
			console.log("we're clicking");
			  mobileNavbarSupportedContent.classList.toggle("show");
		});
	}

	/////////////////////////////////////////////////
	// End: Toggle Mobile Nav
	////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Start: Update User Org Nav Link
	//
	// On the main nav we want to get the link to the user's organization from the link in the header then append it to the "organization Profile" link
	////////////////////////////////////////////////


	let userOrgLinks = document.getElementsByClassName("user-org-link");
	let userOrgLink;

	if(userOrgLinks.length > 0){
		for (let i = 0; i < 1; i++) {
			console.log(userOrgLinks[i].href + ": " + i);

			userOrgLink = userOrgLinks[i].href;

			updateUserOrgNavLink(userOrgLink);

		}

		function updateUserOrgNavLink(link) {
			let userOrgNavLink = document.getElementsByClassName("org-profile-nav-link");
			if(userOrgNavLink){
				for (let i=0; i < userOrgNavLink.length; i++) {
					userOrgNavLink[i].children[0].href = link;
				}
			}
		}
	}


	// This is back up in case the user's status is expired
	// This will only be triggered if the user's memberhsip status is expired
	let expiredOrgLink = document.getElementById("expiredOrgLink");

	if(expiredOrgLink){
		let expiredOrdLinkVal = expiredOrgLink.getAttribute('data-org-id');
		let expiredOrdLinkUrl = expiredOrgLink.getAttribute('data-org-url');

		let userOrgNavLink = document.getElementsByClassName("org-profile-nav-link");
			if(userOrgNavLink){
				for (let i=0; i < userOrgNavLink.length; i++) {
					userOrgNavLink[i].children[0].href = expiredOrdLinkUrl;
				}
			}
	}

	/////////////////////////////////////////////////
	// End: Update User Org Nav Link
	////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Start: Add data attributes to main nav links
	//
	// Becuase the main nav links are being rendered dynamically through Wordpress, we cannot hardcode the data attributes. This script will add the data attributes to each link
	////////////////////////////////////////////////
	/*
	const navLinks = document.querySelectorAll('#menu-main-menu .menu-item .nav-link');

	if (navLinks) {
		navLinks.forEach((navLink) => {
			

			let navLinkUrl = navLink.getAttribute('href');

			navLink.setAttribute('data-title', navLink.innerHTML);
			navLink.setAttribute('data-link', navLinkUrl);
			//console.log(navLink.innerHTML);
			//console.log(navLinkUrl);
		});
	}
	*/
	/////////////////////////////////////////////////
	// End: Add data attributes to main nav links
	////////////////////////////////////////////////

	let eventRadioToggle = document.querySelector('input[type="radio"].event-radio-toggle');

	if (eventRadioToggle) {
		console.log('Event toggle exists');

		setTimeout(() => {
			document.getElementById('eventMonthView').style.display = 'none';
		}, 300);

		
		document.querySelectorAll('input[type="radio"].event-radio-toggle').forEach(radio => {
		radio.addEventListener('change', function() {
			const selectedValue = this.value;
			
			// Hide all content divs
			// document.getElementById('content1').style.display = 'none';
			// document.getElementById('content2').style.display = 'none';

			this.classList.add(selectedValue);
			//this.classList.remove("active");

			if (selectedValue == "list") {
				document.getElementById('eventListView').style.display = 'block';
				document.getElementById('eventMonthView').style.display = 'none';
			} else if (selectedValue == "calendar") {
				document.getElementById('eventMonthView').style.display = 'block';
				document.getElementById('eventListView').style.display = 'none';
			}


		});

	});
		
	} else {
		// console.log('Event toggle does not exist');
	}

		/////////////////////////////////////////////////
	// Start: Hide/Show breadcrumbs for Org Profile
	//
	////////////////////////////////////////////////

	let currentUrl = window.location.href;

	let edit_profile_field = 'edit_profile=true';
	let membership_dashboard_field = 'membership_dashboard=true';
	let manage_disease_rels_field = 'manage_disease_rels=true';
	let manage_users_field = 'manage_users=true';

	let breadcrumbs = document.getElementsByClassName("breadcrumb");

	// If URL has query parameter "?edit_profile=true" remove the general breadcrumbs
	if(
		currentUrl.indexOf('?' + edit_profile_field) != -1 || currentUrl.indexOf('&' + edit_profile_field) != -1 ||
		currentUrl.indexOf('?' + membership_dashboard_field) != -1 || currentUrl.indexOf('&' + membership_dashboard_field) != -1 ||
		currentUrl.indexOf('?' + manage_disease_rels_field) != -1 || currentUrl.indexOf('&' + manage_disease_rels_field) != -1 ||
		currentUrl.indexOf('?' + manage_users_field) != -1 || currentUrl.indexOf('&' + manage_users_field) != -1
	){

		if (breadcrumbs){
			for (let i = 0; i < breadcrumbs.length; i++) {
				breadcrumbs[i].style.display = "none";
			}
		}

		//Find element where we'll put the custom breadcrumb above
		let memberOrgHeader = document.getElementById("memberOrgHeader");

		const currentUrl_ = new URL(window.location.href);
		// Remove query parameters
		currentUrl_.search = '';
		const urlWithoutQueryParams = currentUrl_.toString();

		// Create a new anchor element and add class with link and text
		const newAnchor = document.createElement('a');
		newAnchor.classList.add('manage-profile-breadcrumb');
		newAnchor.setAttribute('href', urlWithoutQueryParams); 
		newAnchor.textContent = '<< Back to Organization Profile page'; 

		// Add new element above Member Org Header
		memberOrgHeader.before(newAnchor);

	}

	/////////////////////////////////////////////////
	// Start: Sortable Table
	////////////////////////////////////////////////

	const sortableTable = document.querySelector('.manage-users-table');

	if (sortableTable) {
		const headers = sortableTable.querySelectorAll('thead th');
		const tbody = sortableTable.querySelector('tbody');

		headers.forEach((header, index) => {
			// Skip the last column (Actions)
			if (index === headers.length - 1) return;

			header.addEventListener('click', () => {
				const rows = Array.from(tbody.querySelectorAll('tr'));
				const isAscending = header.classList.contains('sort-asc');

				// Remove sort classes from all headers
				headers.forEach(h => h.classList.remove('sort-asc', 'sort-desc'));

				// Sort rows
				rows.sort((a, b) => {
					const aText = a.cells[index].textContent.trim().toLowerCase();
					const bText = b.cells[index].textContent.trim().toLowerCase();

					if (aText < bText) return isAscending ? 1 : -1;
					if (aText > bText) return isAscending ? -1 : 1;
					return 0;
				});

				// Add sort class to current header
				header.classList.add(isAscending ? 'sort-desc' : 'sort-asc');

				// Re-append sorted rows
				rows.forEach(row => tbody.appendChild(row));
			});
		});
	}

	/////////////////////////////////////////////////
	// End: Sortable Table
	////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Start: Inline Role Editing
	////////////////////////////////////////////////

	const roleOptions = [
		'Primary Contact',
		'Renewal Contact',
		'Executive Leadership',
		'Board Member',
		'Medical/Scientific Advisor',
		'Accounting/Finance Contact',
		'Policy/Advocacy Contact',
		'Staff Member',
		'Other'
	];

	// Get ajax URL from table data attribute
	const manageUsersTable = document.querySelector('.manage-users-table');
	const ajaxUrl = manageUsersTable ? manageUsersTable.dataset.ajaxurl : '/wp-admin/admin-ajax.php';

	document.querySelectorAll('.editable-role').forEach(roleSpan => {
		roleSpan.addEventListener('click', function(e) {
			e.stopPropagation();

			// Don't create another dropdown if already editing
			if (this.classList.contains('editing')) return;

			const userId = this.dataset.userId;
			const currentRole = this.dataset.currentRole;
			const nonce = this.dataset.nonce;
			const originalText = this.textContent.trim();

			// Mark as editing
			this.classList.add('editing');

			// Create select dropdown
			const select = document.createElement('select');
			select.className = 'role-select';

			// Add empty option
			const emptyOption = document.createElement('option');
			emptyOption.value = '';
			emptyOption.textContent = '— Select Role —';
			select.appendChild(emptyOption);

			// Add role options
			roleOptions.forEach(role => {
				const option = document.createElement('option');
				option.value = role;
				option.textContent = role;
				if (role === currentRole) {
					option.selected = true;
				}
				select.appendChild(option);
			});

			// Replace span content with select
			this.textContent = '';
			this.appendChild(select);
			select.focus();

			// Handle change
			select.addEventListener('change', () => {
				const newRole = select.value;

				// Show loading state
				this.classList.add('saving');
				this.classList.remove('editing');
				this.textContent = 'Saving...';

				// AJAX request
				fetch(ajaxUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: new URLSearchParams({
						action: 'nord_update_user_role',
						user_id: userId,
						role: newRole,
						nonce: nonce
					})
				})
				.then(response => response.json())
				.then(data => {
					this.classList.remove('saving');
					if (data.success) {
						this.textContent = data.data.role;
						this.dataset.currentRole = newRole;
					} else {
						this.textContent = originalText;
						alert('Error: ' + (data.data?.message || 'Failed to update role'));
					}
				})
				.catch(error => {
					this.classList.remove('saving');
					this.textContent = originalText;
					alert('Error updating role');
					console.error('Error:', error);
				});
			});

			// Handle click outside to cancel
			const handleClickOutside = (event) => {
				if (!this.contains(event.target)) {
					this.classList.remove('editing');
					this.textContent = originalText;
					document.removeEventListener('click', handleClickOutside);
				}
			};

			// Handle escape key to cancel
			select.addEventListener('keydown', (event) => {
				if (event.key === 'Escape') {
					this.classList.remove('editing');
					this.textContent = originalText;
					document.removeEventListener('click', handleClickOutside);
				}
			});

			// Delay adding click listener to avoid immediate trigger
			setTimeout(() => {
				document.addEventListener('click', handleClickOutside);
			}, 0);
		});
	});

	/////////////////////////////////////////////////
	// End: Inline Role Editing
	////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Start: Close Access Notification Message Box
	////////////////////////////////////////////////

	let blockAccessCloseBtn = document.getElementById("blockAccessCloseBtn");

	if(blockAccessCloseBtn) {
		console.log("ibfnviudbvuxdnvdxukfvxdjiofvndilfvbdxlufvb wowwwwwww");
		let blockAccessMsg = document.getElementById("blockAccessMsg");

		blockAccessCloseBtn.addEventListener('click', function() {
			blockAccessMsg.style.display = "none";
		});
	}

	/////////////////////////////////////////////////
	//  End: Close Access Notification Banner Message Box
	////////////////////////////////////////////////


	blockAccessCloseBtn

});
